import { useTranslation } from "react-i18next";
import CenteredMessageBox from "../general/CenteredMessageBox";

/** What stands on a page of probabilities once the court has decided. */
export const JudgedState = () => {
  const { t } = useTranslation(undefined, { keyPrefix: "case.judged" });
  return <CenteredMessageBox message={t("message")} />;
};
